import Phaser from 'phaser';
import { CONFIG } from '../config.js';

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameOverScene' });
  }

  init(data) {
    this.runStats = data.runStats || {};
    this.level = data.level || 'basic';
  }

  create() {
    const W = CONFIG.GAME_WIDTH;
    const H = CONFIG.GAME_HEIGHT;

    this.add.tileSprite(0, 0, W, H, 'tile-grass').setOrigin(0, 0).setAlpha(0.4);
    this.add.rectangle(0, 0, W, H, 0x000000, 0.7).setOrigin(0, 0);

    const title = this.add
      .text(W / 2, H * 0.22, 'GAME\nOVER', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '52px',
        color: '#ef4444',
        stroke: '#0f0d2c',
        strokeThickness: 8,
        align: 'center',
        lineSpacing: 8,
      })
      .setOrigin(0.5);
    this.tweens.add({
      targets: title,
      alpha: { from: 0, to: 1 },
      scale: { from: 0.6, to: 1 },
      duration: 600,
      ease: 'Back.easeOut',
    });

    const stats = [
      `SCORE       ${this.runStats.score || 0}`,
      `WAVE REACH  ${this.runStats.waveReached || 1}`,
      `KILLS       ${this.runStats.kills || 0}`,
      `BEST COMBO  x${this.runStats.bestCombo || 0}`,
      `CORRECT     ${this.runStats.correct || 0}`,
      `WRONG       ${this.runStats.wrong || 0}`,
    ];

    this.add
      .text(W / 2, H * 0.5, stats.join('\n'), {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '11px',
        color: '#ffffff',
        align: 'center',
        lineSpacing: 12,
      })
      .setOrigin(0.5);

    this.makeButton(W / 2, H * 0.76, 220, 56, 'RETRY', 0xd946ef, () => {
      this.scene.start('GameScene', { level: this.level });
    });
    this.makeButton(W / 2, H * 0.86, 220, 38, 'MENU', 0x312e81, () => {
      this.scene.start('MenuScene');
    }, '12px');

    this.add
      .text(W / 2, H - 14, 'by Pixie Studios  ·  2026', {
        fontFamily: '"Press Start 2P", monospace',
        fontSize: '7px',
        color: '#9ca3af',
      })
      .setOrigin(0.5);
  }

  makeButton(x, y, w, h, label, fillColor, onClick, fontSize = '16px') {
    const bg = this.add.rectangle(x, y, w, h, fillColor).setStrokeStyle(3, 0xffffff, 0.95);
    const text = this.add
      .text(x, y, label, {
        fontFamily: '"Press Start 2P", monospace',
        fontSize,
        color: '#ffffff',
      })
      .setOrigin(0.5);
    bg.setInteractive({ useHandCursor: true });
    bg.on('pointerover', () => bg.setScale(1.04));
    bg.on('pointerout', () => bg.setScale(1));
    bg.on('pointerdown', () => bg.setScale(0.96));
    bg.on('pointerup', () => {
      bg.setScale(1);
      onClick();
    });
    return { bg, text };
  }
}
